var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{mediumFont: _vm.mediumSize, largeFont: _vm.largeSize},attrs:{"dark":_vm.goDark}},[(!_vm.isPrinting)?_c('loader',{staticClass:"no-print"}):_vm._e(),_c('egranty-snackbar',{staticClass:"no-print"}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }